import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
    plugins: [createPersistedState()],
    state: {
        isLogin: false,
        auth: {
            token: '',
            name: '',
            mobile: '',
            avatar: ''
        },
        remPwdObj:{
            rem:false,
            pwd:null,
            mobile: null
        },
        school_city: [],
        grade: [],

        payModelInfo:{
            openPayModal:false,
            pay_code:'',
            my_code:'',
            price: null,
            // paySetInterval: null,
            order_no: null,

            // paySuccessImg:require('@/assets/img/success.png')
        },
        paySuccess:false,
    },
    mutations: {
        SET_ISLOGIN(state, val) {
            state.isLogin = val;
        },
        SET_USER_NAME(state, name) {
            state.auth.name = name;
        },
        SET_MOBILE(state, mobile) {
            state.auth.mobile = mobile;
        },
        SET_LOGOUT(state) {
            state.auth = {};
            state.isLogin = false;
        },
        SET_USER_AVATAR(state, val) {
            state.auth.avatar = val
        },
        SET_AUTH(state, val) {
            state.auth = Object.assign(state.auth, {token: val})
        },
        SET_USERINFO(state, obj) {
            state.auth = Object.assign(state.auth, obj.user)
            state.school_city = obj.school_city
            state.grade = obj.grade
        },
        SET_REMPWD(state, val) {
            state.remPwdObj.rem = val
        },
        SET_PWD(state, val) {
            state.remPwdObj.pwd = val.pwd
            state.remPwdObj.mobile = val.mobile
        },
        // // 支付弹窗信息存储
        // OPEN_PAY_MODEL(state,val) {
        //     console.log(val,'val')
        //     state.payModelInfo = val
        // },
        // // 支付成功
        // SET_PAY_SUCCESS(state,val) {
        //     state.paySuccess = val
        // }
    },
    actions: {},
    modules: {}
})
